import Cargos from '@/models/Cargos'

import ligacoesRotas from './routes/ligacoes.rotas'

// eslint-disable-next-line
export const rotasContatos = {
  modulo: 'contato',
  label: 'Contatos',
  icon: 'headset',
  mostrarMenu: true,
  cargos: [Cargos.ATENDENTE, Cargos.LIDER],
  rotas: [...ligacoesRotas],
}
